(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8059],{

/***/ 27805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[market]",
      function () {
        return __webpack_require__(89847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ FloatingNavigationBar; },
/* harmony export */   "w": function() { return /* binding */ ActiveTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2267);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);


var ActiveTab;
(function(ActiveTab) {
    ActiveTab["Browse"] = "browse";
    ActiveTab["Favorites"] = "favorites";
})(ActiveTab || (ActiveTab = {}));
var FloatingNavigationBar = function(param) {
    var activeTab = param.activeTab, handleOnViewBrowse = param.handleOnViewBrowse, handleOnViewFavorites = param.handleOnViewFavorites, _shouldHide = param.shouldHide, shouldHide = _shouldHide === void 0 ? false : _shouldHide;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        "$platform-web": {
            position: "fixed"
        },
        bottom: shouldHide ? -100 : 20,
        left: 0,
        right: 0,
        zIndex: 2000,
        height: 70,
        width: 410,
        alignSelf: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        margin: "auto",
        mb: 10,
        $smallerThanMD: {
            width: 210
        },
        backgroundColor: "$backgroundPrimary",
        py: 0,
        px: 10,
        shadow: "$default",
        borderRadius: "$4x",
        style: {
            transition: "bottom 0.25s"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .PressableBox */ .K, {
                "aria-label": "Browse",
                width: 200,
                height: 50,
                marginHorizontal: "auto",
                padding: 6,
                analyticsName: "browse-toggle",
                "data-testid": "browse-toggle-button",
                alignSelf: "center",
                onPress: handleOnViewBrowse,
                $smallerThanMD: {
                    width: 100
                },
                backgroundColor: activeTab === ActiveTab.Browse ? "$backgroundInversePrimary" : "$backgroundPrimary",
                borderBottomLeftRadius: "$4x",
                borderBottomRightRadius: activeTab === ActiveTab.Browse ? "$4x" : "$2x",
                borderTopRightRadius: activeTab === ActiveTab.Browse ? "$4x" : "$2x",
                borderTopLeftRadius: "$4x",
                py: 30,
                shadow: "$default",
                pressStyle: {
                    backgroundColor: "$backgroundInversePrimary"
                },
                hoverStyle: {
                    backgroundColor: activeTab === ActiveTab.Browse ? "$backgroundInversePrimary" : "$backgroundTertiary"
                },
                style: {
                    transition: "background-color 0.25s"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    color: activeTab === ActiveTab.Browse ? "$contentInverseTertiary" : "$contentTertiary",
                    tag: "span",
                    typography: "$labelLarge",
                    children: "Browse"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .PressableBox */ .K, {
                "aria-label": "Favorites",
                width: 200,
                height: 50,
                marginHorizontal: "auto",
                padding: 6,
                analyticsName: "favorites-toggle",
                "data-testid": "browfavoritesse-toggle-button",
                alignSelf: "center",
                onPress: handleOnViewFavorites,
                backgroundColor: activeTab === ActiveTab.Favorites ? "$backgroundInversePrimary" : "$backgroundPrimary",
                py: 30,
                borderBottomLeftRadius: activeTab === ActiveTab.Favorites ? "$4x" : "$2x",
                borderBottomRightRadius: "$4x",
                borderTopLeftRadius: activeTab === ActiveTab.Favorites ? "$4x" : "$2x",
                borderTopRightRadius: "$4x",
                $smallerThanMD: {
                    width: 100
                },
                shadow: "$default",
                pressStyle: {
                    backgroundColor: "$backgroundInversePrimary"
                },
                hoverStyle: {
                    backgroundColor: activeTab === ActiveTab.Favorites ? "$backgroundInversePrimary" : "$backgroundTertiary"
                },
                style: {
                    transition: "background-color 0.25s"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    color: activeTab === "favorites" ? "$contentInverseTertiary" : "$contentTertiary",
                    tag: "span",
                    typography: "$labelLarge",
                    children: "Favorites"
                })
            })
        ]
    });
};


/***/ }),

/***/ 89847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _market_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(24697);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(64211);
// EXTERNAL MODULE: ./src/components/marketplace/FloatingNavigationBar.tsx
var FloatingNavigationBar = __webpack_require__(90325);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(95707);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useMapRefs.ts

var useMapRefs = function() {
    var smallMap = (0,react.useRef)(null);
    var mediumMap = (0,react.useRef)(null);
    var largeMap = (0,react.useRef)(null);
    return {
        smallMap: smallMap,
        mediumMap: mediumMap,
        largeMap: largeMap
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSearchQueries.ts






var getPropertyList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload, page) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                    page: page
                }))
            ];
        });
    });
    return function getPropertyList(payload, page) {
        return _ref.apply(this, arguments);
    };
}();
var getPropertyListAndSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
        var page, searchResult, listResult;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySearch((0,_object_spread/* default */.Z)({}, payload))
                    ];
                case 1:
                    searchResult = _state.sent();
                    return [
                        4,
                        getPropertyList(payload, page)
                    ];
                case 2:
                    listResult = _state.sent();
                    return [
                        2,
                        {
                            searchResult: searchResult,
                            listResult: listResult
                        }
                    ];
            }
        });
    });
    return function getPropertyListAndSearch(payload) {
        return _ref.apply(this, arguments);
    };
}();
var updateQueryParams = function(input) {
    var queryParams = buildQueryParams(input);
    window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(queryParams));
};
var buildQueryParams = function(input) {
    var urlParams = new URLSearchParams(window.location.search);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(input)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (key === "zoneIds") {
                urlParams.set("zoneIds", value === null || value === void 0 ? void 0 : value.join(","));
            } else if (key === "vertices") {
                value.forEach(function(vertex, indx) {
                    urlParams.set("vertex_".concat(indx), encodeURI(JSON.stringify(vertex)));
                });
            } else if (key === "market") {
                urlParams.set("market", value);
            } else if (typeof value === "boolean") {
                urlParams.set(key, value.toString());
            } else if (value) {
                urlParams.set(key, value.toString());
            } else {
                urlParams.delete(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return urlParams;
};
var buildVerticesQueryParams = function(vertices) {
    var urlParams = new URLSearchParams(window.location.search);
    vertices.forEach(function(vertex, indx) {
        urlParams.set("vertex_".concat(indx), encodeURI(JSON.stringify(vertex)));
    });
    return urlParams;
};
var buildAddressPreviewParams = function(addressToken) {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set("preview_aid", addressToken);
    return urlParams;
};
var removeAddressPreviewParams = function() {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("preview_aid");
    return urlParams;
};
// Maps URL param aliases to their canonical PropertySearchQuery field names
var PARAM_ALIASES = {
    minBeds: "bedrooms",
    minBaths: "bathrooms",
    minPrice: "minListPrice",
    maxPrice: "maxListPrice",
    singleStory: "hasSingleStory",
    mustHavePool: "hasPool"
};
var parseQueryParams = function(urlParams) {
    var queryParams = {};
    queryParams.vertices = [];
    Object.entries(urlParams).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    }).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var normalizedKey = PARAM_ALIASES[key] || key;
        if (normalizedKey === "zoneIds" && typeof value === "string") {
            queryParams.zoneIds = value.split(",");
        } else if (key.startsWith("vertex_") && typeof value === "string") {
            queryParams.vertices.push(JSON.parse(decodeURI(value)));
        } else {
            if (!isNaN(Number(value))) {
                queryParams[normalizedKey] = Number(value);
            } else if (value === "true" || value === "false") {
                queryParams[normalizedKey] = value === "true";
            } else {
                queryParams[normalizedKey] = value;
            }
        }
    });
    return queryParams;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/marketplace/search/utils.ts

/**
 * For use with Dropdown values and options to prevent invalid states in filter ranges
 *
 * @param options a list of RangeOptions for a Dropdown
 * @param op whether options should be accepted above or below the limit
 * @param limit a stringified integer representing the limit
 * @returns the filtered list of RangeOptionsZ
 */ var filterIntOptions = function(options, op, limit) {
    if (!limit) {
        return options.slice();
    }
    var limitVal = parseInt(limit, 10);
    if (isNaN(limitVal)) {
        return options.slice();
    }
    return options.filter(function(option) {
        var val = parseInt(option.value, 10);
        if (op === "gt") {
            return val > limitVal;
        }
        return val < limitVal;
    });
};
var MapSearchZoom;
(function(MapSearchZoom) {
    MapSearchZoom[MapSearchZoom["CITY"] = 9] = "CITY";
    MapSearchZoom[MapSearchZoom["ZIP"] = 11] = "ZIP";
    MapSearchZoom[MapSearchZoom["NEIGHBORHOOD"] = 13] = "NEIGHBORHOOD";
})(MapSearchZoom || (MapSearchZoom = {}));
// Based on API limits
var MAX_MARKETS = 150;
// Fallback market when none specified or invalid
var DEFAULT_MARKET = "PHOENIX";
var getZoomForLocationType = function(zoneType) {
    if (zoneType === "(Zip code)") {
        return MapSearchZoom.ZIP;
    }
    if (zoneType === "(Neighborhood)") {
        return MapSearchZoom.NEIGHBORHOOD;
    }
    return MapSearchZoom.CITY;
};
/**
 * Convert GeoJSON polygon coordinates to GeoPoint format
 */ var convertToGeoPointVertices = function(vertices) {
    var ref;
    return (ref = vertices === null || vertices === void 0 ? void 0 : vertices.map(function(polygon) {
        return polygon.map(function(param) {
            var _param = _sliced_to_array(param, 2), lon = _param[0], lat = _param[1];
            return {
                lon: lon,
                lat: lat
            };
        });
    })) !== null && ref !== void 0 ? ref : [];
};
var buildPropertyTypes = function(singleFamily, condo, townhome) {
    var propertyTypes = [];
    if (singleFamily) {
        propertyTypes.push("HOUSE");
    }
    if (condo) {
        propertyTypes.push("CONDO");
    }
    if (townhome) {
        propertyTypes.push("TOWNHOUSE");
    }
    return propertyTypes;
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSearchState.ts





var getInitialPropertyTypes = function(queryParams) {
    var hasAnyPropertyTypeParam = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.singleFamily) !== undefined || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.condo) !== undefined || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.townhome) !== undefined;
    if (hasAnyPropertyTypeParam) {
        var ref, ref1, ref2;
        return {
            singleFamily: (ref = queryParams === null || queryParams === void 0 ? void 0 : queryParams.singleFamily) !== null && ref !== void 0 ? ref : false,
            condo: (ref1 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.condo) !== null && ref1 !== void 0 ? ref1 : false,
            townhome: (ref2 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.townhome) !== null && ref2 !== void 0 ? ref2 : false
        };
    }
    return {
        singleFamily: true,
        condo: true,
        townhome: true
    };
};
var useSearchState = function(queryParams) {
    var initialPropertyTypes = getInitialPropertyTypes(queryParams);
    var ref = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.bedrooms) || 0), minBeds = ref[0], setBedrooms = ref[1];
    var ref1 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.bathrooms) || 0), minBaths = ref1[0], setBathrooms = ref1[1];
    var ref2 = (0,react.useState)(null), canSelfTour = ref2[0], setCanSelfTour = ref2[1];
    var ref3 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minListPrice) || null), minPrice = ref3[0], setMinPrice = ref3[1];
    var ref4 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxListPrice) || null), maxPrice = ref4[0], setMaxPrice = ref4[1];
    var ref5 = (0,react.useState)(initialPropertyTypes.singleFamily), singleFamily = ref5[0], setSingleFamily = ref5[1];
    var ref6 = (0,react.useState)(initialPropertyTypes.condo), condo = ref6[0], setCondo = ref6[1];
    var ref7 = (0,react.useState)(initialPropertyTypes.townhome), townhome = ref7[0], setTownhome = ref7[1];
    var ref8 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.noHoas) || false), noHoas = ref8[0], setNoHoas = ref8[1];
    var ref9 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.hasSingleStory) || false), singleStory = ref9[0], setSingleStory = ref9[1];
    var ref10 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.hasPool) || false), mustHavePool = ref10[0], setMustHavePool = ref10[1];
    var ref11 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minYearBuilt) || null), minYearBuilt = ref11[0], setMinYearBuilt = ref11[1];
    var ref12 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxYearBuilt) || null), maxYearBuilt = ref12[0], setMaxYearBuilt = ref12[1];
    var ref13 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minLotSize) || null), minLotSize = ref13[0], setMinLotSize = ref13[1];
    var ref14 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxLotSize) || null), maxLotSize = ref14[0], setMaxLotSize = ref14[1];
    var ref15 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minSquareFootage) || null), minSquareFootage = ref15[0], setMinSquareFootage = ref15[1];
    var ref16 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxSquareFootage) || null), maxSquareFootage = ref16[0], setMaxSquareFootage = ref16[1];
    var ref17 = (0,react.useState)(0), pageNumber = ref17[0], setPageNumber = ref17[1];
    var resetPage = function() {
        return setPageNumber(0);
    };
    var resetFilters = function() {
        setBathrooms(0);
        setBedrooms(0);
        setCanSelfTour(null);
        setCondo(true);
        setMaxLotSize(null);
        setMaxPrice(null);
        setMaxSquareFootage(null);
        setMaxYearBuilt(null);
        setMinLotSize(null);
        setMinPrice(null);
        setMinSquareFootage(null);
        setMinYearBuilt(null);
        setMustHavePool(false);
        setNoHoas(false);
        setPageNumber(0);
        setSingleFamily(true);
        setSingleStory(false);
        setTownhome(true);
    };
    var buildSearchPayload = function(override) {
        var ref;
        var _ref = override || {}, vertices = _ref.vertices, zoneIds = _ref.zoneIds, market = _ref.market, restOverrides = (0,_object_without_properties/* default */.Z)(_ref, [
            "vertices",
            "zoneIds",
            "market"
        ]);
        var propertyTypes = buildPropertyTypes(singleFamily, condo, townhome);
        var payload = (0,_object_spread/* default */.Z)({
            bathrooms: minBaths,
            bedrooms: minBeds,
            canSelfTour: canSelfTour,
            hasPool: mustHavePool,
            maxListPrice: maxPrice,
            maxSquareFootage: maxSquareFootage,
            maxYearBuilt: maxYearBuilt,
            minListPrice: minPrice,
            minSquareFootage: minSquareFootage,
            minYearBuilt: minYearBuilt,
            propertyTypes: propertyTypes,
            singleStoryOnly: singleStory
        }, restOverrides);
        // Location handling (mutually exclusive: vertices > zoneIds > market)
        if (override === null || override === void 0 ? void 0 : (ref = override.vertices) === null || ref === void 0 ? void 0 : ref.length) {
            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                vertices: vertices
            });
        } else if (override === null || override === void 0 ? void 0 : override.zoneIds) {
            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                zoneIds: zoneIds
            });
        } else if (override === null || override === void 0 ? void 0 : override.market) {
            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                market: market
            });
        }
        return payload;
    };
    var getCanonical = function() {
        return {
            bedrooms: minBeds,
            bathrooms: minBaths,
            canSelfTour: canSelfTour,
            minListPrice: minPrice,
            maxListPrice: maxPrice,
            singleFamily: singleFamily,
            condo: condo,
            townhome: townhome,
            noHoas: noHoas,
            hasSingleStory: singleStory,
            hasPool: mustHavePool,
            minYearBuilt: minYearBuilt,
            maxYearBuilt: maxYearBuilt,
            minLotSize: minLotSize,
            maxLotSize: maxLotSize,
            minSquareFootage: minSquareFootage,
            maxSquareFootage: maxSquareFootage
        };
    };
    return {
        resetFilters: resetFilters,
        resetPage: resetPage,
        buildSearchPayload: buildSearchPayload,
        getCanonical: getCanonical,
        get: {
            minBeds: minBeds,
            minBaths: minBaths,
            canSelfTour: canSelfTour,
            minPrice: minPrice,
            maxPrice: maxPrice,
            singleFamily: singleFamily,
            condo: condo,
            townhome: townhome,
            noHoas: noHoas,
            singleStory: singleStory,
            mustHavePool: mustHavePool,
            minYearBuilt: minYearBuilt,
            maxYearBuilt: maxYearBuilt,
            minLotSize: minLotSize,
            maxLotSize: maxLotSize,
            minSquareFootage: minSquareFootage,
            maxSquareFootage: maxSquareFootage,
            pageNumber: pageNumber
        },
        set: {
            setBedrooms: setBedrooms,
            setBathrooms: setBathrooms,
            setCanSelfTour: setCanSelfTour,
            setMinPrice: setMinPrice,
            setMaxPrice: setMaxPrice,
            setSingleFamily: setSingleFamily,
            setCondo: setCondo,
            setTownhome: setTownhome,
            setNoHoas: setNoHoas,
            setSingleStory: setSingleStory,
            setMustHavePool: setMustHavePool,
            setMinYearBuilt: setMinYearBuilt,
            setMaxYearBuilt: setMaxYearBuilt,
            setMinLotSize: setMinLotSize,
            setMaxLotSize: setMaxLotSize,
            setMinSquareFootage: setMinSquareFootage,
            setMaxSquareFootage: setMaxSquareFootage,
            setPageNumber: setPageNumber
        }
    };
};

// EXTERNAL MODULE: ./src/components/marketplace/map/MarketplaceMap.tsx
var MarketplaceMap = __webpack_require__(40818);
// EXTERNAL MODULE: ./src/components/marketplace/map/MapMarker.tsx
var MapMarker = __webpack_require__(86230);
;// CONCATENATED MODULE: ./src/components/marketplace/map/MarketplaceMapMarker.tsx






var MarketplaceMapMarker = function(param) {
    var index = param.index, detailCache = param.detailCache, property = param.property, handleFetchPropertyDetails = param.handleFetchPropertyDetails, propertyReactions = param.propertyReactions, isSelected = param.isSelected, isLoading = param.isLoading;
    var ref, ref1;
    var addressToken = property.addressToken;
    if (addressToken === null || addressToken === undefined) {
        return null;
    }
    var lat = (ref = property.location) === null || ref === void 0 ? void 0 : ref.lat;
    if (lat === undefined) {
        return null;
    }
    var lon = (ref1 = property.location) === null || ref1 === void 0 ? void 0 : ref1.lon;
    if (lon === undefined) {
        return null;
    }
    var handleOnClick = function() {
        handleFetchPropertyDetails(addressToken);
        var urlParams = buildAddressPreviewParams(addressToken);
        window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
    };
    var markerProperty = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property), {
        addressToken: addressToken,
        location: {
            lat: lat,
            lon: lon
        },
        isLiked: (propertyReactions === null || propertyReactions === void 0 ? void 0 : propertyReactions[addressToken]) === "REACTION_LIKE"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapMarker/* MapMarker */.O, {
        property: markerProperty,
        index: index,
        detailCache: detailCache,
        onClick: handleOnClick,
        isSelected: isSelected,
        isLoading: isLoading
    }, property.addressToken);
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Divider/Divider.mjs
var Divider = __webpack_require__(11061);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarousel.js + 1 modules
var PhotoCarousel = __webpack_require__(29434);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
;// CONCATENATED MODULE: ./src/components/marketplace/map/types.ts
var MOBILE_CAROUSEL_HEIGHT_SM = 260;
var MOBILE_CAROUSEL_HEIGHT_MD = 414;

;// CONCATENATED MODULE: ./src/components/marketplace/map/PhotoCarousel.tsx





var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
var PhotoCarousel_PhotoCarousel = function(param) {
    var photos = param.photos, onClose = param.onClose, _isRounded = param.isRounded, isRounded = _isRounded === void 0 ? false : _isRounded, onOpenShareModal = param.onOpenShareModal, onPhotoClick = param.onPhotoClick, height = param.height;
    var ref = (0,react.useState)(PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT), aspectRatio = ref[0], setAspectRatio = ref[1];
    var ref1 = (0,react.useState)(false), shouldHideNavigation = ref1[0], setShouldHideNavigation = ref1[1];
    var carouselRef = (0,react.useRef)(null);
    var mappedPhotos = (0,react.useMemo)(function() {
        return (photos === null || photos === void 0 ? void 0 : photos.map(function(photo) {
            return {
                url: photo + "?service=cosmos&preset=3%3A2-md&presetScale=2%2F3&dpr=1",
                alt: ""
            };
        }, [
            photos
        ])) || [];
    }, [
        photos
    ]);
    (0,react.useEffect)(function() {
        var carousel = carouselRef.current;
        var startY = 0;
        var startX = 0;
        var handleTouchStart = function(e) {
            startY = e.touches[0].clientY; // Set start Y to the initial touch Y position
            startX = e.touches[0].clientX; // Set start X to the initial touch X position
        };
        var handleTouchMove = function(e) {
            // Calculate the difference between current touch position and start position
            var moveY = e.touches[0].clientY - startY;
            var moveX = e.touches[0].clientX - startX;
            // We're doing this because we want to allow vertical scrolling
            // if the user starts scrolling vertically first
            // But if they start scrolling horizontally first, we want to prevent vertical scrolling
            if (Math.abs(moveX) > Math.abs(moveY)) {
                e.preventDefault(); // Prevent Vertical scrolling
            } else {
                e.stopPropagation(); // Prevent Horizontal scrolling
            }
        };
        if (carousel) {
            carousel.addEventListener("touchstart", handleTouchStart, {
                passive: true
            });
            carousel.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
        }
        return function() {
            if (carousel) {
                // Clean up event listeners
                carousel.removeEventListener("touchstart", handleTouchStart);
                carousel.removeEventListener("touchmove", handleTouchMove);
            }
        };
    }, [
        carouselRef
    ]);
    (0,react.useEffect)(function() {
        var carousel = carouselRef.current;
        if (!carousel) return;
        var handleClick = function(e) {
            var tag = e.target.tagName;
            if (tag === "IMG" && onPhotoClick) {
                onPhotoClick();
            }
        };
        carousel.addEventListener("click", handleClick);
        return function() {
            carousel.removeEventListener("click", handleClick);
        };
    }, [
        carouselRef
    ]);
    var CarouselWidths = {
        smallest: 360,
        small: 375,
        smallMedium: 600,
        medium: 768,
        mediumLarge: 992
    };
    var _obj;
    var WIDTH_TO_ASPECT_RATIO = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CarouselWidths.smallest, PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT), (0,_define_property/* default */.Z)(_obj, CarouselWidths.small, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.smallMedium, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.medium, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), (0,_define_property/* default */.Z)(_obj, CarouselWidths.mediumLarge, PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE), _obj);
    useIsomorphicLayoutEffect(function() {
        // Function to calculate and set the aspect ratio
        var updateAspectRatio = function() {
            var containerWidth = window.innerWidth;
            var newAspectRatio = PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT; // Default aspect ratio
            var shouldHideNav = false;
            if (containerWidth < CarouselWidths.smallest) {
                newAspectRatio = PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT;
                shouldHideNav = true;
            } else if (containerWidth <= CarouselWidths.small) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.small];
                shouldHideNav = true;
            } else if (containerWidth < CarouselWidths.smallMedium) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.smallMedium];
                shouldHideNav = true;
            } else if (containerWidth <= CarouselWidths.medium) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.medium];
                shouldHideNav = false;
            } else if (containerWidth <= CarouselWidths.mediumLarge) {
                newAspectRatio = WIDTH_TO_ASPECT_RATIO[CarouselWidths.mediumLarge];
                shouldHideNav = false;
            }
            setShouldHideNavigation(shouldHideNav);
            setAspectRatio(newAspectRatio);
        };
        // Call updateAspectRatio initially to set the aspect ratio based on the current window size
        updateAspectRatio();
        // Add event listener for window resize
        window.addEventListener("resize", updateAspectRatio);
        // Cleanup function to remove the event listener
        return function() {
            return window.removeEventListener("resize", updateAspectRatio);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        position: "relative",
        aspectRatio: aspectRatio,
        justifyContent: "center",
        overflow: "hidden",
        width: "100%",
        ref: carouselRef,
        $smallerThanMD: {
            height: MOBILE_CAROUSEL_HEIGHT_SM
        },
        $smallerThanLG: {
            height: MOBILE_CAROUSEL_HEIGHT_MD
        },
        $largerThanMD: {
            mt: 0
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                id: "close-button",
                size: "large",
                onPress: onClose,
                analyticsName: "marketplace-carousel-back-button",
                top: "$8x",
                left: 24,
                position: "absolute",
                zIndex: 1,
                "data-testid": "map-pdp-close-button"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ShareButton */.Tz, {
                id: "share-button",
                size: "large",
                onPress: onOpenShareModal,
                analyticsName: "marketplace-carousel-share-button",
                top: "$8x",
                right: 24,
                position: "absolute",
                zIndex: 1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel/* PhotoCarousel */.c, {
                photos: mappedPhotos,
                hideNavigation: shouldHideNavigation,
                aspectRatio: aspectRatio,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                height: height || "100%",
                isRounded: isRounded || false
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 12 modules
var marketplace_property = __webpack_require__(19585);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyCTAs.tsx + 2 modules
var PropertyCTAs = __webpack_require__(28561);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyDetails.tsx + 3 modules
var PropertyDetails = __webpack_require__(20313);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyStatus.tsx
var PropertyStatus = __webpack_require__(46609);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertySummary.tsx
var PropertySummary = __webpack_require__(21572);
// EXTERNAL MODULE: ./src/components/shared/hooks/useInView.tsx
var useInView = __webpack_require__(53456);
;// CONCATENATED MODULE: ./src/components/marketplace/map/MiniPropertyDetailPage.tsx












var MiniPropertyDetailPage = function(param) {
    var property = param.property, onClose = param.onClose;
    var ref = (0,react.useState)(false), isShareModalOpen = ref[0], setIsShareModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), isLightboxOpen = ref1[0], setIsLightboxOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var ctaRef = (0,react.useRef)(null);
    var inView = (0,useInView/* useInViewAfterLoad */.D)({
        ref: ctaRef,
        threshold: 0,
        initialInView: true
    }).inView;
    if (!property) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {});
    }
    var handleOnClose = function() {
        var urlParams = removeAddressPreviewParams();
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        onClose();
    };
    var handleToggleShareModal = function() {
        setIsShareModalOpen(function(prev) {
            return !prev;
        });
    };
    var toggleLightbox = function() {
        setIsLightboxOpen(function(prev) {
            return !prev;
        });
        setSelectedPhotoIndex(0);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        height: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                photos: property === null || property === void 0 ? void 0 : property.photos,
                onClose: handleOnClose,
                onOpenShareModal: handleToggleShareModal,
                onPhotoClick: toggleLightbox
            }, "mini-pdp-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        px: 48,
                        pt: 24,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyStatus/* PropertyStatus */.R, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertySummary/* PropertySummary */.b, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                ref: ctaRef,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyCTAs/* PropertyCTAs */.y, {
                                    property: property
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                                mt: 48
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyDetails/* PropertyDetails */.l, {
                                property: property
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* FooterCTA */.Vf, {
                        property: property,
                        isVisible: !inView
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* Lightbox */.ey, {
                        handleClose: toggleLightbox,
                        isOpen: isLightboxOpen,
                        property: property,
                        selectedPhotoIndex: selectedPhotoIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                property: property,
                isOpen: isShareModalOpen,
                onClose: handleToggleShareModal
            }, "share-modal-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
        ]
    }, "mini-pdp-".concat(property === null || property === void 0 ? void 0 : property.addressToken));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/TextInput.js
var TextInput = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useOutsideCaller.ts


var useOutsideCaller = function(cb, refs) {
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            var target = null;
            if ((0,_instanceof/* default */.Z)(event.target, Node)) {
                target = event.target;
            }
            if (refs.every(function(ref) {
                return !ref.current || !ref.current.contains(target);
            })) {
                cb();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        refs
    ]);
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/LocationSearch.tsx










var formatZoneType = function(zoneType) {
    switch(zoneType){
        case "CITY":
            return "(City)";
        case "COUNTY":
            return "(County)";
        case "ZIP_CODE":
            return "(Zip code)";
        case "NEIGHBORHOOD":
        case "SUBNEIGHBORHOOD":
        case "MACRO_NEIGHBORHOOD":
            return "(Neighborhood)";
        default:
            return "";
    }
};
var QUERY_STRING_MIN_LENGTH = 2;
var MapLocationSearch = function(param) {
    var isFocused = param.isFocused, selectedAddress = param.selectedAddress, setSelectedAddress = param.setSelectedAddress, selectedLocation = param.selectedLocation, setSelectedLocation = param.setSelectedLocation;
    var ref = (0,react.useState)(selectedLocation ? [
        selectedLocation
    ] : undefined), locationOptions = ref[0], setLocationOptions = ref[1];
    var ref1 = (0,react.useState)(), addressOptions = ref1[0], setAddressOptions = ref1[1];
    var ref2 = (0,react.useState)(), query = ref2[0], setQuery = ref2[1];
    var ref3 = (0,react.useState)(false), isLocationFocused = ref3[0], setIsLocationFocused = ref3[1];
    var ref4 = (0,react.useState)(false), isDropdownFocused = ref4[0], setIsDropdownFocused = ref4[1];
    var containerRef = (0,react.useRef)(null);
    var debouncedSearchLocations = (0,react.useMemo)(function() {
        var fetchLocations = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(queryStr) {
                var ref, ref1, ref2, ref3, ref4, types, locationsResp, addressResp, zones;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(queryStr && queryStr.length > QUERY_STRING_MIN_LENGTH)) return [
                                3,
                                3
                            ];
                            types = queryStr.match(/^\d/) ? [
                                "ZIP_CODE"
                            ] : [
                                "CITY",
                                "NEIGHBORHOOD",
                                "SUBNEIGHBORHOOD"
                            ];
                            return [
                                4,
                                (0,api/* getAthenaClient */.k8)().SearchLocations({
                                    query: queryStr,
                                    types: types
                                })
                            ];
                        case 1:
                            locationsResp = _state.sent();
                            return [
                                4,
                                (0,api/* getAthenaClient */.k8)().AddressSearch({
                                    query: queryStr
                                })
                            ];
                        case 2:
                            addressResp = _state.sent();
                            zones = locationsResp === null || locationsResp === void 0 ? void 0 : (ref = locationsResp.geoDataStore) === null || ref === void 0 ? void 0 : (ref1 = ref.searchZonesByTextQuery) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.zones) === null || ref2 === void 0 ? void 0 : ref2.map(function(result) {
                                var ref;
                                var zone = result.zone;
                                return {
                                    label: (zone === null || zone === void 0 ? void 0 : zone.name) + ", " + (zone === null || zone === void 0 ? void 0 : zone.stateAbbr),
                                    zoneType: formatZoneType(zone === null || zone === void 0 ? void 0 : zone.zoneType),
                                    value: zone === null || zone === void 0 ? void 0 : zone.uuid,
                                    coordinates: (zone === null || zone === void 0 ? void 0 : zone.centroid) ? (ref = JSON.parse(zone === null || zone === void 0 ? void 0 : zone.centroid)) === null || ref === void 0 ? void 0 : ref.coordinates : [
                                        0,
                                        0
                                    ],
                                    population: zone === null || zone === void 0 ? void 0 : zone.population
                                };
                            }).sort(function(a, b) {
                                if (a.population && b.population) {
                                    return b.population - a.population;
                                }
                                return 0;
                            });
                            setLocationOptions(zones);
                            setAddressOptions((addressResp === null || addressResp === void 0 ? void 0 : (ref3 = addressResp.marketplace) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addressSearch) === null || ref4 === void 0 ? void 0 : ref4.properties) || []);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setLocationOptions(undefined);
                            setAddressOptions(undefined);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLocations(queryStr) {
                return _ref.apply(this, arguments);
            };
        }();
        return debounce_default()(fetchLocations, 500);
    }, []);
    (0,react.useEffect)(function() {
        debouncedSearchLocations(query);
        return function() {
            return debouncedSearchLocations.cancel();
        };
    }, [
        query,
        debouncedSearchLocations
    ]);
    useOutsideCaller(function() {
        setIsLocationFocused(false);
        setIsDropdownFocused(false);
    }, [
        containerRef
    ]);
    var handleLocationSearch = function(search) {
        setQuery(search);
    };
    var handleLocationFocus = function() {
        setIsLocationFocused(true);
        setQuery("");
        setSelectedLocation(undefined);
        setSelectedAddress(undefined);
    };
    var handleDropdownFocus = function() {
        return setIsDropdownFocused(true);
    };
    var handleDropdownBlur = function() {
        setIsLocationFocused(false);
        setIsDropdownFocused(false);
    };
    var handleLocationSelect = function(e) {
        if (!(0,_instanceof/* default */.Z)(e.target, HTMLElement)) {
            return;
        }
        if (e.target.dataset.location) {
            var selectedLoc = JSON.parse(e.target.dataset.location);
            setSelectedLocation(selectedLoc);
            setSelectedAddress(undefined);
            handleDropdownBlur();
            handleLocationSearch("");
        }
    };
    var handleAddressSelect = function(e) {
        if (!(0,_instanceof/* default */.Z)(e.target, HTMLElement)) {
            return;
        }
        if (e.target.dataset.addresstoken) {
            var selectedAddr = addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.find(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            function(addr) {
                var ref, ref1;
                return addr.addressToken === (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.dataset) === null || ref1 === void 0 ? void 0 : ref1.addresstoken);
            });
            if (selectedAddr) {
                setSelectedAddress(selectedAddr);
                setSelectedLocation(undefined);
                handleDropdownBlur();
                handleLocationSearch("");
            }
        }
    };
    var shouldShowDropdown = (0,react.useMemo)(function() {
        return query && ((locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.length) || (addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.length)) && (isLocationFocused || isDropdownFocused);
    }, [
        query,
        locationOptions,
        addressOptions,
        isLocationFocused,
        isDropdownFocused
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "label",
                typography: "$labelMedium",
                color: "$contentPrimary",
                mb: 12,
                $smallerThanMD: {
                    display: "none"
                },
                children: "Location"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                ariaLabel: "Location search",
                id: "locations-search",
                "data-testid": "location-search-input",
                name: "locations",
                size: "small",
                $smallerThanMD: {
                    size: "xsmall",
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    width: "85%"
                },
                ml: isFocused ? 20 : 0,
                placeholder: "City, address, zip",
                onChangeText: handleLocationSearch,
                onFocus: handleLocationFocus,
                prefilledValue: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.fullAddress) || (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label)
            }, (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.fullAddress) || (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                id: "locations",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        zIndex: 10000,
                        backgroundColor: "$backgroundPrimary",
                        position: "absolute",
                        height: 25,
                        display: shouldShowDropdown ? "flex" : "none",
                        width: "100%",
                        borderStyle: "solid",
                        borderColor: "$borderAccentBrand",
                        borderTopWidth: 0,
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderBottomWidth: 0,
                        left: 0,
                        top: -15,
                        onFocus: handleDropdownFocus,
                        onBlur: handleDropdownBlur
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        position: "absolute",
                        backgroundColor: "$backgroundPrimary",
                        zIndex: 10000,
                        height: 400,
                        display: shouldShowDropdown ? "flex" : "none",
                        width: "100%",
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderBottomLeftRadius: "$8x",
                        borderLeftWidth: 1,
                        borderBottomRightRadius: "$8x",
                        borderTopWidth: 0,
                        borderColor: "$borderAccentBrand",
                        left: 0,
                        top: 5,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        overflowY: "scroll",
                        overflowX: "hidden",
                        onFocus: handleDropdownFocus,
                        onBlur: handleDropdownBlur,
                        children: [
                            query && (locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.length) && locationOptions.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: "$backgroundPrimary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelSmall",
                                        ml: 20,
                                        children: "Locations"
                                    }),
                                    locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.map(function(item, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            borderBottomWidth: 1,
                                            borderBottomColor: "$borderSecondary",
                                            alignItems: "flex-start",
                                            hoverStyle: {
                                                backgroundColor: "$backgroundSecondary"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                                "aria-label": "Select ".concat(item.label),
                                                "data-testid": "search-result-".concat(item.value),
                                                analyticsName: "comos-map-select-location",
                                                onPress: handleLocationSelect,
                                                position: "relative",
                                                px: 20,
                                                py: 20,
                                                mt: index === 0 ? 10 : 0,
                                                flexDirection: "row",
                                                pressStyle: {
                                                    backgroundColor: "$backgroundSecondary"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$bodySmall",
                                                    "data-location": JSON.stringify(item),
                                                    children: [
                                                        item.label,
                                                        " ",
                                                        item.zoneType
                                                    ]
                                                })
                                            })
                                        }, item.label);
                                    })
                                ]
                            }) : null,
                            query && addressOptions && (addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.length) > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: "$backgroundPrimary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        mt: 24,
                                        typography: "$labelSmall",
                                        ml: 20,
                                        children: "Listings"
                                    }),
                                    addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.map(function(item, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            borderBottomWidth: 1,
                                            borderBottomColor: "$borderSecondary",
                                            alignItems: "flex-start",
                                            hoverStyle: {
                                                backgroundColor: "$backgroundSecondary"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                                "aria-label": "Select ".concat(item.fullAddress),
                                                analyticsName: "cosmos-map-select-address",
                                                onPress: handleAddressSelect,
                                                position: "relative",
                                                px: 20,
                                                py: 20,
                                                mt: index === 0 ? 10 : 0,
                                                flexDirection: "row",
                                                pressStyle: {
                                                    backgroundColor: "$backgroundSecondary"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$bodySmall",
                                                            width: "100%",
                                                            "data-addresstoken": item.addressToken,
                                                            children: item.fullAddress
                                                        }),
                                                        item.priceCents && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$labelXsmall",
                                                            alignSelf: "flex-start",
                                                            "data-addresstoken": item.addressToken,
                                                            children: (0,currencyHelpers/* formatCurrency */.xG)(item.priceCents / 100)
                                                        })
                                                    ]
                                                })
                                            })
                                        }, item.fullAddress);
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }, "location-results-".concat(query))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/MobileHeaderFilters.tsx



var MobileHeaderFilters = function(param) {
    var isFocused = param.isFocused, selectedLocation = param.selectedLocation, setSelectedLocation = param.setSelectedLocation, onBack = param.onBack, onOpenFilters = param.onOpenFilters, selectedAddress = param.selectedAddress, setSelectedAddress = param.setSelectedAddress;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapLocationSearch, {
                selectedAddress: selectedAddress,
                setSelectedAddress: setSelectedAddress,
                setSelectedLocation: setSelectedLocation,
                selectedLocation: selectedLocation,
                isFocused: isFocused
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "absolute",
                backgroundColor: "$backgroundPrimary",
                top: 10,
                right: "5%",
                zIndex: 10000,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* FilterButton */.Lb, {
                    size: "small",
                    analyticsName: "cosmos-marketplace-map-header-filter-button",
                    onPress: onOpenFilters
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "absolute",
                backgroundColor: "$backgroundPrimary",
                top: 10,
                left: "2%",
                zIndex: 10000,
                display: isFocused ? "flex" : "none",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronBackButton */.jd, {
                    size: "small",
                    analyticsName: "cosmos-marketplace-map-location-search-back-button",
                    onPress: onBack
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/es/formatUtils.mjs
var formatUtils = __webpack_require__(64260);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/Pricing.tsx
var Pricing = __webpack_require__(79338);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/MiniMapPropertySummary.tsx





var MiniMapPropertySummary = function(param) {
    var property = param.property;
    var ref, ref1;
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        tag: "hgroup",
        $largerThanMD: {
            display: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "h1",
                pb: 24,
                color: "$contentPrimary",
                fontWeight: "$regular",
                typography: "$subheaderXsmall",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderXsmall",
                        fontWeight: "$regular",
                        children: formattedStreet
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderXsmall",
                        fontWeight: "$regular",
                        children: [
                            property.city,
                            ", ",
                            property.state,
                            " ",
                            property.zip
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "section",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pricing/* PricingTraditional */.n, {
                        listPrice: property === null || property === void 0 ? void 0 : property.listPrice
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.bedrooms,
                                    " bds"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.bathrooms,
                                    " ba"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.sqFtTotalLiving,
                                    " sqft"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: (property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment) && "".concat((0,formatUtils/* formatCurrency */.xG)(property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment), "/month est.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "row",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodySmall",
                            color: "$contentSecondary",
                            children: !!(property === null || property === void 0 ? void 0 : (ref = property.schoolDistricts) === null || ref === void 0 ? void 0 : ref.length) && "".concat(property === null || property === void 0 ? void 0 : (ref1 = property.schoolDistricts) === null || ref1 === void 0 ? void 0 : ref1.join(" & "))
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/MobileMiniPropertyDetailPage.tsx








var SWIPE_THRESHOLD = 50;
var MobileMiniPropertyDetailPage = function(param) {
    var property = param.property, onClose = param.onClose;
    var ref = (0,react.useState)(false), isShareModalOpen = ref[0], setIsShareModalOpen = ref[1];
    var ref1 = (0,react.useState)(null), swipeStartY = ref1[0], setSwipeStartY = ref1[1];
    var handleTouchStart = function(e) {
        var touch = e.touches[0];
        setSwipeStartY(touch.clientY);
    };
    var handleOnClose = function() {
        var urlParams = removeAddressPreviewParams();
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        onClose();
    };
    var handleToggleShareModal = function() {
        setIsShareModalOpen(function(prev) {
            return !prev;
        });
    };
    // Handle the end of the touch and check if it's a swipe down
    var handleTouchEnd = function(e) {
        if (swipeStartY === null) return;
        var touch = e.changedTouches[0];
        var swipeDistance = touch.clientY - swipeStartY;
        if (swipeDistance > SWIPE_THRESHOLD) {
            handleOnClose();
        }
        setSwipeStartY(null);
    };
    var handleOnClick = function() {
        window.location.href = "/properties/".concat(property === null || property === void 0 ? void 0 : property.slug, "/aid_").concat(property === null || property === void 0 ? void 0 : property.addressToken);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                backgroundColor: "$backgroundPrimary",
                width: "100%",
                borderTopLeftRadius: "$16x",
                borderTopRightRadius: "$16x",
                height: "75vh",
                flexDirection: "column",
                onTouchStart: handleTouchStart,
                onTouchEnd: handleTouchEnd,
                exitStyle: {
                    height: "0vh"
                },
                animation: "accelerateSlow",
                touchAction: "none",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $largerThanSM: {
                            height: MOBILE_CAROUSEL_HEIGHT_MD
                        },
                        mb: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                            photos: property === null || property === void 0 ? void 0 : property.photos,
                            onClose: handleOnClose,
                            onOpenShareModal: handleToggleShareModal,
                            isRounded: true,
                            height: MOBILE_CAROUSEL_HEIGHT_MD,
                            onPhotoClick: handleOnClick
                        }, "med-mobile-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            height: MOBILE_CAROUSEL_HEIGHT_SM
                        },
                        $largerThanSM: {
                            display: "none"
                        },
                        mb: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                            photos: property === null || property === void 0 ? void 0 : property.photos,
                            onClose: handleOnClose,
                            onOpenShareModal: handleToggleShareModal,
                            isRounded: true,
                            height: MOBILE_CAROUSEL_HEIGHT_SM,
                            onPhotoClick: handleOnClick
                        }, "sm-mobile-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        px: 20,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiniMapPropertySummary, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                analyticsName: "mobile-map-pdp-link",
                                href: "/properties/".concat(property === null || property === void 0 ? void 0 : property.slug, "/aid_").concat(property === null || property === void 0 ? void 0 : property.addressToken),
                                size: "small",
                                variant: "secondary",
                                label: "View home",
                                mt: 10
                            })
                        ]
                    })
                ]
            }, "mobile-mini-pdp-".concat(property === null || property === void 0 ? void 0 : property.addressToken)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                property: property,
                isOpen: isShareModalOpen,
                onClose: handleToggleShareModal
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Loader/Loader.js + 10 modules
var Loader = __webpack_require__(8537);
;// CONCATENATED MODULE: ./src/components/marketplace/map/PropertyList.tsx






var PropertyList = function(param) {
    var isLoading = param.isLoading, handleOnSeeMore = param.handleOnSeeMore, propertyListData = param.propertyListData;
    var ref = (0,react.useState)(false), isLoadingMore = ref[0], setIsLoadingMore = ref[1];
    var propertyCards = (0,react.useMemo)(function() {
        var ref;
        return propertyListData === null || propertyListData === void 0 ? void 0 : (ref = propertyListData.results) === null || ref === void 0 ? void 0 : ref.map(function(listing, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                mb: 24,
                $largerThanXS: {
                    width: "100%"
                },
                $largerThanSM: {
                    width: "100%"
                },
                $largerThanMD: {
                    width: "48%"
                },
                $largerThanLG: {
                    width: "48%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ListingCard */.dF, {
                    listing: listing
                })
            }, index);
        });
    }, [
        propertyListData
    ]);
    var onSeeMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingMore(true);
                        return [
                            4,
                            handleOnSeeMore()
                        ];
                    case 1:
                        _state.sent();
                        setTimeout(function() {
                            return setIsLoadingMore(false);
                        }, 500);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSeeMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexWrap: "wrap",
                justifyContent: "space-between",
                flexDirection: "row",
                "data-testid": "map-property-list",
                children: isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* Loader */.a, {
                        backgroundColor: "$backgroundPrimary",
                        size: "large"
                    })
                }) : propertyCards
            }),
            (propertyListData === null || propertyListData === void 0 ? void 0 : propertyListData.nextPage) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "more-property-list",
                "data-testid": "map-more-property-list",
                label: "Show more",
                onPress: onSeeMore,
                size: "medium",
                variant: "secondary",
                mb: 30,
                loading: isLoadingMore
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/Dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(62742);
;// CONCATENATED MODULE: ./src/components/marketplace/map/QuickFilters.tsx



var QuickFilters = function(param) {
    var bathrooms = param.bathrooms, bedrooms = param.bedrooms, onFilterChange = param.onFilterChange, isLoadingFilter = param.isLoadingFilter, setSelectedAddress = param.setSelectedAddress, selectedAddress = param.selectedAddress, setSelectedLocation = param.setSelectedLocation, selectedLocation = param.selectedLocation, onFiltersButtonClick = param.onFiltersButtonClick, isFocused = param.isFocused;
    var handleOnBedroomsChange = function(value) {
        onFilterChange(value, bathrooms);
    };
    var handleOnBathroomsChange = function(value) {
        onFilterChange(bedrooms, value);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        justifyContent: "space-between",
        flexDirection: "row",
        width: "100%",
        my: 25,
        gap: 20,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flex: 2,
                width: "40%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapLocationSearch, {
                    isFocused: isFocused,
                    selectedAddress: selectedAddress,
                    setSelectedAddress: setSelectedAddress,
                    setSelectedLocation: setSelectedLocation,
                    selectedLocation: selectedLocation
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                flex: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                    id: "bedrooms",
                    name: "bedrooms",
                    prefilledValue: (bedrooms === null || bedrooms === void 0 ? void 0 : bedrooms.toString()) || undefined,
                    options: [
                        {
                            label: "1+",
                            value: "1"
                        },
                        {
                            label: "2+",
                            value: "2"
                        },
                        {
                            label: "3+",
                            value: "3"
                        },
                        {
                            label: "4+",
                            value: "4"
                        }, 
                    ],
                    placeholderOption: {
                        label: "0",
                        value: undefined
                    },
                    size: "small",
                    title: "Beds",
                    onValueChange: handleOnBedroomsChange
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                flex: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                    id: "bathrooms",
                    name: "bathrooms",
                    prefilledValue: (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.toString()) || undefined,
                    options: [
                        {
                            label: "1+",
                            value: "1"
                        },
                        {
                            label: "2+",
                            value: "2"
                        },
                        {
                            label: "3+",
                            value: "3"
                        },
                        {
                            label: "4+",
                            value: "4"
                        }, 
                    ],
                    placeholderOption: {
                        label: "0",
                        value: undefined
                    },
                    size: "small",
                    title: "Baths",
                    onValueChange: handleOnBathroomsChange
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "filter-property-search",
                "data-testid": "filter-property-search",
                label: "Filters",
                onPress: onFiltersButtonClick,
                size: "xsmall",
                variant: "secondary",
                height: "65%",
                alignSelf: "flex-end",
                flex: 1,
                maxWidth: 82,
                minWidth: "min-content",
                loading: isLoadingFilter
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/BedroomsBathroomsFilter.tsx


var RoomSizeOptions = [
    {
        label: "1+",
        value: "1"
    },
    {
        label: "2+",
        value: "2"
    },
    {
        label: "3+",
        value: "3"
    },
    {
        label: "4+",
        value: "4"
    }, 
];
var BedroomsBathroomsFilter = function(param) {
    var minBaths = param.minBaths, minBeds = param.minBeds, handleMinBathsChange = param.handleMinBathsChange, handleMinBedsChange = param.handleMinBedsChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Beds/Baths"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        mt: 24,
                        children: "Beds"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "30%",
                        $smallerThanMD: {
                            width: "40%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "Min beds",
                                value: "0"
                            },
                            options: RoomSizeOptions.slice(),
                            onValueChange: handleMinBedsChange,
                            size: "small",
                            prefilledValue: minBeds || undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        mt: 24,
                        children: "Baths"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "30%",
                        $smallerThanMD: {
                            width: "40%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "Min baths",
                                value: "0"
                            },
                            options: RoomSizeOptions.slice(),
                            onValueChange: handleMinBathsChange,
                            size: "small",
                            prefilledValue: minBaths || undefined
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(44468);
;// CONCATENATED MODULE: ./src/components/marketplace/search/HomeFeaturesFilter.tsx


var HomeFeaturesFilter = function(param) {
    var noHoas = param.noHoas, fhaEligible = param.fhaEligible, mustHavePool = param.mustHavePool, singleStory = param.singleStory, handleNoHoasChange = param.handleNoHoasChange, handleFhaEligibleChange = param.handleFhaEligibleChange, handleSingleStoryChange = param.handleSingleStoryChange, handlePoolChange = param.handlePoolChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                color: "$contentPrimary",
                alignSelf: "flex-start",
                mb: 20,
                children: "Home features"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "No HOA Only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "hoa-checkbox",
                        analyticsName: "hoa-checkbox",
                        id: "hoa-checkbox",
                        size: "medium",
                        name: "hoa",
                        value: "true",
                        defaultChecked: !!noHoas,
                        onPress: handleNoHoasChange
                    })
                ]
            }),
            handleSingleStoryChange && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Single-story only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "single-story-checkbox",
                        analyticsName: "single-story-checkbox",
                        id: "single-story-checkbox",
                        size: "medium",
                        name: "singleStory",
                        value: "true",
                        defaultChecked: !!singleStory,
                        onPress: handleSingleStoryChange
                    })
                ]
            }),
            handleFhaEligibleChange && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "FHA Eligible Only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "fha-checkbox",
                        analyticsName: "fha-checkbox",
                        id: "fha-checkbox",
                        size: "medium",
                        name: "fha",
                        value: "true",
                        defaultChecked: !!fhaEligible,
                        onPress: handleFhaEligibleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "With Pool Only (includes community pools)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "pool-checkbox",
                        analyticsName: "pool-checkbox",
                        id: "pool-checkbox",
                        size: "medium",
                        name: "pool",
                        value: "true",
                        defaultChecked: !!mustHavePool,
                        onPress: handlePoolChange
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/HomeTypeFilter.tsx


var HomeTypeFilter = function(param) {
    var singleFamily = param.singleFamily, townhome = param.townhome, condo = param.condo, handleSingleFamilyChange = param.handleSingleFamilyChange, handleTownhomeChange = param.handleTownhomeChange, handleCondoChange = param.handleCondoChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                color: "$contentPrimary",
                alignSelf: "flex-start",
                mb: 20,
                children: "Home type"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Single-family homes"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "single-family-home-checkbox",
                        analyticsName: "sfh-checkbox",
                        id: "single-family-home-checkbox",
                        size: "medium",
                        name: "singleFamily",
                        value: "true",
                        defaultChecked: !!singleFamily,
                        onPress: handleSingleFamilyChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Townhomes"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "townhome-checkbox",
                        analyticsName: "townhome-checkbox",
                        id: "townhome-checkbox",
                        size: "medium",
                        name: "townhome",
                        value: "true",
                        defaultChecked: !!townhome,
                        onPress: handleTownhomeChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Condos"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "condo-checkbox",
                        analyticsName: "condo-checkbox",
                        id: "condo-checkbox",
                        size: "medium",
                        name: "condo",
                        value: "true",
                        defaultChecked: !!condo,
                        onPress: handleCondoChange
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/LotSizeFilter.tsx



var LotSizeOptions = [
    {
        label: "2000 sq ft",
        value: "2000"
    },
    {
        label: "4000 sq ft",
        value: "4000"
    },
    {
        label: "6000 sq ft",
        value: "6000"
    },
    {
        label: "8000 sq ft",
        value: "8000"
    },
    {
        label: "0.25 acres",
        value: "10890"
    },
    {
        label: "0.5 acres",
        value: "21780"
    },
    {
        label: "1 acre",
        value: "43560"
    },
    {
        label: "2 acres+",
        value: "87120"
    }, 
];
var LotSizeFilter = function(param) {
    var minLotSize = param.minLotSize, maxLotSize = param.maxLotSize, handleMinLotSizeChange = param.handleMinLotSizeChange, handleMaxLotSizeChange = param.handleMaxLotSizeChange, handleError = param.handleError, errors = param.errors;
    var onMinLotSizeChange = function(value) {
        if (maxLotSize && parseInt(value, 10) > parseInt(maxLotSize, 10)) {
            handleError("minLotSize", "Min lot size must be less than max lot size");
            return;
        }
        handleError("minLotSize", "");
        handleMinLotSizeChange(value);
    };
    var onMaxLotSizeChange = function(value) {
        if (minLotSize && parseInt(value, 10) < parseInt(minLotSize, 10)) {
            handleError("maxLotSize", "Max lot size must be greater than min lot size");
            return;
        }
        handleError("maxLotSize", "");
        handleMaxLotSizeChange(value);
    };
    var minOptions = filterIntOptions(LotSizeOptions, "lt", maxLotSize !== null && maxLotSize !== void 0 ? maxLotSize : undefined);
    var maxOptions = filterIntOptions(LotSizeOptions, "gt", minLotSize !== null && minLotSize !== void 0 ? minLotSize : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Lot size"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-lot-size-dropdown",
                            options: minOptions,
                            onValueChange: onMinLotSizeChange,
                            size: "small",
                            prefilledValue: minLotSize || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minLotSize"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            "data-testid": "max-lot-size-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxLotSizeChange,
                            size: "small",
                            prefilledValue: maxLotSize || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxLotSize"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/PriceFilter.tsx



var PriceRangeOptions = [
    {
        label: "$100,000",
        value: "10000000"
    },
    {
        label: "$200,000",
        value: "20000000"
    },
    {
        label: "$300,000",
        value: "30000000"
    },
    {
        label: "$400,000",
        value: "40000000"
    },
    {
        label: "$500,000",
        value: "50000000"
    },
    {
        label: "$600,000",
        value: "60000000"
    },
    {
        label: "$700,000",
        value: "70000000"
    },
    {
        label: "$800,000",
        value: "80000000"
    },
    {
        label: "$900,000",
        value: "90000000"
    },
    {
        label: "$1,000,000",
        value: "100000000"
    },
    {
        label: "$1,250,000",
        value: "125000000"
    },
    {
        label: "$1,500,000",
        value: "150000000"
    },
    {
        label: "$1,750,000",
        value: "175000000"
    }, 
];
var PriceFilter = function(param) {
    var minPrice = param.minPrice, maxPrice = param.maxPrice, handleMinPriceChange = param.handleMinPriceChange, handleMaxPriceChange = param.handleMaxPriceChange, handleError = param.handleError, errors = param.errors;
    var onMinPriceChange = function(value) {
        if (maxPrice && parseInt(value, 10) > parseInt(maxPrice, 10)) {
            handleError("minPrice", "Min price must be less than max price");
            return;
        }
        handleError("minPrice", "");
        handleMinPriceChange(value);
    };
    var onMaxPriceChange = function(value) {
        if (minPrice && parseInt(value, 10) < parseInt(minPrice, 10)) {
            handleError("maxPrice", "Max price must be greater than min price");
            return;
        }
        handleError("maxPrice", "");
        handleMaxPriceChange(value);
    };
    var minOptions = filterIntOptions(PriceRangeOptions, "lt", maxPrice !== null && maxPrice !== void 0 ? maxPrice : undefined);
    var maxOptions = filterIntOptions(PriceRangeOptions, "gt", minPrice !== null && minPrice !== void 0 ? minPrice : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Price range"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            id: "price-filter-min",
                            "data-testid": "price-filter-min",
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            options: minOptions,
                            onValueChange: onMinPriceChange,
                            size: "small",
                            prefilledValue: minPrice || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minPrice"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            id: "price-filter-max",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            options: maxOptions.concat({
                                label: "$2,000,000+",
                                value: "500000000"
                            }),
                            onValueChange: onMaxPriceChange,
                            size: "small",
                            prefilledValue: maxPrice || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxPrice"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/SquareFootageFilter.tsx



var SquareFootageOptions = [
    {
        label: "1,000 sq ft",
        value: "1000"
    },
    {
        label: "1,500 sq ft",
        value: "1500"
    },
    {
        label: "2,000 sq ft",
        value: "2000"
    },
    {
        label: "2,500 sq ft",
        value: "2500"
    },
    {
        label: "3,000 sq ft",
        value: "3000"
    },
    {
        label: "3,500 sq ft",
        value: "3500"
    },
    {
        label: "4,000 sq ft",
        value: "4000"
    },
    {
        label: "5,000 sq ft",
        value: "5000"
    }, 
];
var SquareFootageFilter = function(param) {
    var minSquareFootage = param.minSquareFootage, maxSquareFootage = param.maxSquareFootage, handleMinSquareFootageChange = param.handleMinSquareFootageChange, handleMaxSquareFootageChange = param.handleMaxSquareFootageChange, handleError = param.handleError, errors = param.errors;
    var onMinSquareFootageChange = function(value) {
        if (maxSquareFootage && parseInt(value, 10) >= parseInt(maxSquareFootage, 10)) {
            handleError("minSquareFootage", "Min square footage must be less than max square footage");
            return;
        }
        handleError("minSquareFootage", "");
        handleMinSquareFootageChange(value);
    };
    var onMaxSquareFootageChange = function(value) {
        if (minSquareFootage && parseInt(value, 10) < parseInt(minSquareFootage, 10)) {
            handleError("maxSquareFootage", "Max square footage must be greater than min square footage");
            return;
        }
        handleError("maxSquareFootage", "");
        handleMaxSquareFootageChange(value);
    };
    var minOptions = filterIntOptions(SquareFootageOptions, "lt", maxSquareFootage !== null && maxSquareFootage !== void 0 ? maxSquareFootage : undefined);
    var maxOptions = filterIntOptions(SquareFootageOptions, "gt", minSquareFootage !== null && minSquareFootage !== void 0 ? minSquareFootage : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Square feet"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-square-footage-dropdown",
                            options: minOptions,
                            onValueChange: onMinSquareFootageChange,
                            size: "small",
                            prefilledValue: minSquareFootage || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minSquareFootage"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "10000"
                            },
                            "data-testid": "max-square-footage-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxSquareFootageChange,
                            size: "small",
                            prefilledValue: maxSquareFootage || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxSquareFootage"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/YearBuiltFilter.tsx



var YearBuiltOptions = [
    {
        label: "1900",
        value: "1900"
    },
    {
        label: "1920",
        value: "1920"
    },
    {
        label: "1940",
        value: "1940"
    },
    {
        label: "1960",
        value: "1960"
    },
    {
        label: "1980",
        value: "1980"
    },
    {
        label: "2000",
        value: "2000"
    },
    {
        label: "2005",
        value: "2005"
    },
    {
        label: "2010",
        value: "2010"
    },
    {
        label: "2015",
        value: "2015"
    },
    {
        label: "2016",
        value: "2016"
    },
    {
        label: "2017",
        value: "2017"
    },
    {
        label: "2018",
        value: "2018"
    },
    {
        label: "2019",
        value: "2019"
    },
    {
        label: "2020",
        value: "2020"
    },
    {
        label: "2021",
        value: "2021"
    },
    {
        label: "2022",
        value: "2022"
    },
    {
        label: "2023",
        value: "2023"
    },
    {
        label: "2024",
        value: "2024"
    }, 
];
var YearBuiltFilter = function(param) {
    var minYearBuilt = param.minYearBuilt, maxYearBuilt = param.maxYearBuilt, handleMinYearBuiltChange = param.handleMinYearBuiltChange, handleMaxYearBuiltChange = param.handleMaxYearBuiltChange, handleError = param.handleError, errors = param.errors;
    var onMinYearBuildChange = function(value) {
        if (maxYearBuilt && parseInt(value, 10) > parseInt(maxYearBuilt, 10)) {
            handleError("minYearBuilt", "Min year built must be less than max year built");
            return;
        }
        handleError("minYearBuilt", "");
        handleMinYearBuiltChange(value);
    };
    var onMaxPriceChange = function(value) {
        if (minYearBuilt && parseInt(value, 10) < parseInt(minYearBuilt, 10)) {
            handleError("maxYearBuilt", "Max year built must be greater than min year built");
            return;
        }
        handleError("maxYearBuilt", "");
        handleMaxYearBuiltChange(value);
    };
    var minOptions = filterIntOptions(YearBuiltOptions, "lt", maxYearBuilt !== null && maxYearBuilt !== void 0 ? maxYearBuilt : undefined);
    var maxOptions = filterIntOptions(YearBuiltOptions, "gt", minYearBuilt !== null && minYearBuilt !== void 0 ? minYearBuilt : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Year built"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-year-built-dropdown",
                            options: minOptions,
                            onValueChange: onMinYearBuildChange,
                            size: "small",
                            prefilledValue: minYearBuilt || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minYearBuilt"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            "data-testid": "max-year-built-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxPriceChange,
                            size: "small",
                            prefilledValue: maxYearBuilt || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxYearBuilt"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/SearchFilters.tsx









var SearchFilters = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceFilter, {
                minPrice: props === null || props === void 0 ? void 0 : props.minPrice,
                maxPrice: props === null || props === void 0 ? void 0 : props.maxPrice,
                handleMinPriceChange: props.handleMinPriceChange,
                handleMaxPriceChange: props.handleMaxPriceChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BedroomsBathroomsFilter, {
                minBaths: props === null || props === void 0 ? void 0 : props.minBaths,
                minBeds: props === null || props === void 0 ? void 0 : props.minBeds,
                handleMinBathsChange: props.handleMinBathsChange,
                handleMinBedsChange: props.handleMinBedsChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeTypeFilter, {
                singleFamily: props === null || props === void 0 ? void 0 : props.singleFamily,
                condo: props === null || props === void 0 ? void 0 : props.condo,
                townhome: props === null || props === void 0 ? void 0 : props.townhome,
                handleSingleFamilyChange: props.handleSingleFamilyChange,
                handleCondoChange: props.handleCondoChange,
                handleTownhomeChange: props.handleTownhomeChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeFeaturesFilter, {
                noHoas: props === null || props === void 0 ? void 0 : props.noHoas,
                singleStory: props === null || props === void 0 ? void 0 : props.singleStory,
                fhaEligible: props === null || props === void 0 ? void 0 : props.fhaEligible,
                mustHavePool: props === null || props === void 0 ? void 0 : props.mustHavePool,
                handleNoHoasChange: props.handleNoHoasChange,
                handleSingleStoryChange: props.handleSingleStoryChange,
                handleFhaEligibleChange: props.handleFhaEligibleChange,
                handlePoolChange: props.handlePoolChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YearBuiltFilter, {
                minYearBuilt: props === null || props === void 0 ? void 0 : props.minYearBuilt,
                maxYearBuilt: props === null || props === void 0 ? void 0 : props.maxYearBuilt,
                handleMinYearBuiltChange: props.handleMinYearBuiltChange,
                handleMaxYearBuiltChange: props.handleMaxYearBuiltChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SquareFootageFilter, {
                minSquareFootage: props === null || props === void 0 ? void 0 : props.minSquareFootage,
                maxSquareFootage: props === null || props === void 0 ? void 0 : props.maxSquareFootage,
                handleMinSquareFootageChange: props.handleMinSquareFootageChange,
                handleMaxSquareFootageChange: props.handleMaxSquareFootageChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                my: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LotSizeFilter, {
                minLotSize: props === null || props === void 0 ? void 0 : props.minLotSize,
                maxLotSize: props === null || props === void 0 ? void 0 : props.maxLotSize,
                handleMinLotSizeChange: props.handleMinLotSizeChange,
                handleMaxLotSizeChange: props.handleMaxLotSizeChange,
                handleError: props.handleError,
                errors: props.errors
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/SearchFilters.tsx







var MapSearchFilters = function(props) {
    // Dropdown in bricks-next only reads prefilledValue on mount (uncontrolled).
    // We use a key to force re-render when filters reset OR when QuickFilters
    // updates bed/bath values externally.
    var ref = (0,react.useState)(0), resetFiltersKey = ref[0], setResetFiltersKey = ref[1];
    var handleResetFilters = function() {
        var ref;
        setResetFiltersKey(function(prev) {
            return prev + 1;
        });
        (ref = props.onResetFilters) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    var searchDisabled = (props === null || props === void 0 ? void 0 : props.errors) ? Object.keys(props.errors).length > 0 : false;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        width: "100%",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "$backgroundPrimary",
        style: {
            overflowY: "scroll",
            overflowX: "hidden"
        },
        "data-testid": "map-search-filters",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "baseline",
                my: 12,
                mx: 36,
                $smallerThanLG: {
                    mx: 12
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$labelLarge",
                        mb: 24,
                        $largerThanMD: {
                            display: "none"
                        },
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                        analyticsName: "close-property-search-filters",
                        "data-testid": "close-property-search-filters",
                        onPress: props.onClose,
                        size: "large",
                        variant: "default",
                        p: 10,
                        $largerThanMD: {
                            p: 0,
                            ml: -10
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                mt: 24,
                mb: 12,
                mx: 36,
                $smallerThanLG: {
                    mx: 24
                },
                children: /*#__PURE__*/ (0,react.createElement)(SearchFilters, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    key: "".concat(resetFiltersKey, "-").concat(props.minBeds, "-").concat(props.minBaths)
                }))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                $smallerThanMD: {
                    justifyContent: "space-between"
                },
                backgroundColor: "$backgroundPrimary",
                bottom: 0,
                gap: 8,
                width: "100%",
                px: 24,
                py: 12,
                zIndex: 1,
                style: {
                    position: "sticky"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "property-search-filters-reset",
                        label: "Reset filters",
                        onPress: handleResetFilters,
                        size: "medium",
                        variant: "secondary",
                        minWidth: 150,
                        $smallerThanMD: {
                            size: "small"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "property-search-filters",
                        label: "Search",
                        onPress: props.onApplyFilters,
                        size: "medium",
                        variant: "primary",
                        loading: props.isLoading,
                        minWidth: 150,
                        $smallerThanMD: {
                            flex: 1,
                            size: "small"
                        },
                        disabled: searchDisabled
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/map/utils.ts
var utils = __webpack_require__(98881);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/helpers/globals.ts
var globals = __webpack_require__(63631);
;// CONCATENATED MODULE: ./src/components/marketplace/MarketplaceSeoHead.tsx



var MarketplaceSeoHead = function(param) {
    var marketInfo = param.marketInfo, activeMarkets = param.activeMarkets, canonicalOverride = param.canonicalOverride;
    var marketDisplayName = marketInfo.displayName || marketInfo.name;
    var currentMarket = activeMarkets.find(function(m) {
        return m.identifier === marketInfo.identifier || m.displayName === marketDisplayName;
    });
    var stateAbbreviation = (currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.displayState) || "";
    var locationText = stateAbbreviation ? "".concat(marketDisplayName, ", ").concat(stateAbbreviation) : marketDisplayName;
    var pageTitle = "Houses for sale in ".concat(marketDisplayName, " | Opendoor");
    var pageDescription = "Explore houses for sale in ".concat(locationText, " with Opendoor. Get instant access to listings, photos, and home details, and schedule self-guided tours today.");
    var canonicalPath = canonicalOverride !== null && canonicalOverride !== void 0 ? canonicalOverride : "/homes/".concat(marketInfo.name.toLowerCase());
    var canonicalUrl = "".concat(globals/* HOMEPAGE_URL */.j_).concat(canonicalPath);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: pageDescription
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/filterHelpers.ts
/**
 * Type conversion helpers for filter components.
 *
 * Filter UI components expect string props (for form inputs),
 * but state/SSR data uses numbers. These helpers formalize
 * the conversion at the component boundary.
 */ /**
 * Converts a number to a string for filter component props.
 * Coalesces undef/null to null.
 */ var toFilterString = function(val) {
    return val != null ? String(val) : null;
};
/**
 * Converts a price in dollars to a display string (cents * 100).
 * Filter components display prices in cents for formatting.
 * Coalesces undef/null to null.
 */ var dollarToCentsString = function(dollars) {
    return dollars != null ? String(dollars * 100) : null;
};

// EXTERNAL MODULE: ./src/components/properties/shared/MarketplaceMapLayout.tsx + 1 modules
var MarketplaceMapLayout = __webpack_require__(80284);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
;// CONCATENATED MODULE: ./src/pages/homes/[market].tsx
































var Page = function(param) {
    var propertyList = param.propertyList, propertySearch = param.propertySearch, marketInfo = param.marketInfo, queryParams = param.queryParams, activeMarkets = param.activeMarkets, header = param.header, footer = param.footer, canonicalOverride = param.canonicalOverride;
    var ref = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref.authentication, user = ref.user;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var isLoggedIn = (authentication === null || authentication === void 0 ? void 0 : authentication.state) === "authenticated";
    var ref1 = useMapRefs(), smallMap = ref1.smallMap, mediumMap = ref1.mediumMap, largeMap = ref1.largeMap;
    // Query results
    var ref2 = (0,react.useState)(propertySearch), propertySearchData = ref2[0], setPropertySearchData = ref2[1];
    var ref3 = (0,react.useState)(propertyList), propertyListData = ref3[0], setPropertyListData = ref3[1];
    var searchState = useSearchState(queryParams);
    var _get = searchState.get, minBeds = _get.minBeds, minBaths = _get.minBaths, canSelfTour = _get.canSelfTour, minPrice = _get.minPrice, maxPrice = _get.maxPrice, singleFamily = _get.singleFamily, condo = _get.condo, townhome = _get.townhome, noHoas = _get.noHoas, singleStory = _get.singleStory, mustHavePool = _get.mustHavePool, minYearBuilt = _get.minYearBuilt, maxYearBuilt = _get.maxYearBuilt, minLotSize = _get.minLotSize, maxLotSize = _get.maxLotSize, minSquareFootage = _get.minSquareFootage, maxSquareFootage = _get.maxSquareFootage, pageNumber = _get.pageNumber;
    // UX states
    var ref4 = (0,react.useState)(false), isLoadingResults = ref4[0], setIsLoadingResults = ref4[1];
    var ref5 = (0,react.useState)(false), isLoadingFilter = ref5[0], setIsLoadingFilter = ref5[1];
    var ref6 = (0,react.useState)(), errors = ref6[0], setErrors = ref6[1];
    var ref7 = (0,react.useState)(false), showList = ref7[0], setShowList = ref7[1];
    var ref8 = (0,react.useState)(false), showFilters = ref8[0], setShowFilters = ref8[1];
    var ref9 = (0,react.useState)(false), showPdp = ref9[0], setShowPdp = ref9[1];
    var ref10 = (0,react.useState)(), propertyReactions = ref10[0], setPropertyReactions = ref10[1];
    var ref11 = (0,react.useState)(FloatingNavigationBar/* ActiveTab.Browse */.w.Browse), activeTab = ref11[0], setActiveTab = ref11[1];
    // Map marker information
    var markerDetailsCache = (0,react.useRef)(new Map());
    var ref12 = (0,react.useState)(null), topMarker = ref12[0], setTopMarker = ref12[1];
    var ref13 = (0,react.useState)(null), loadingAddressToken = ref13[0], setLoadingAddressToken = ref13[1];
    // Location data
    var ref14 = (0,react.useState)(marketInfo.shape.coordinates[0]), vertices = ref14[0], setVertices = ref14[1];
    var ref15 = (0,react.useState)(), selectedLocation = ref15[0], setSelectedLocation = ref15[1];
    var ref16 = (0,react.useState)(), selectedAddress = ref16[0], setSelectedAddress = ref16[1];
    // Individual property details
    var ref17 = (0,react.useState)(), propertyDetails = ref17[0], setPropertyDetails = ref17[1];
    var ref18 = (0,helpers/* usePropertyReactions */.O8)(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken, "REACTION_SOURCE_GALLERY"), isLiked = ref18.isLiked, onClickReaction = ref18.onClickReaction;
    var handleFetchPropertyDetails = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(addressToken) {
            var ref, result, urlParams;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingAddressToken(addressToken);
                        return [
                            4,
                            (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyCoreDetails({
                                addressToken: addressToken
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        setPropertyDetails((ref = result.marketplace) === null || ref === void 0 ? void 0 : ref.property);
                        setShowFilters(false);
                        setShowPdp(true);
                        setLoadingAddressToken(null);
                        urlParams = buildAddressPreviewParams(addressToken);
                        window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
                        return [
                            2
                        ];
                }
            });
        });
        return function(addressToken) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.preview_aid) {
            handleFetchPropertyDetails(queryParams.preview_aid);
        }
    }, [
        queryParams === null || queryParams === void 0 ? void 0 : queryParams.preview_aid
    ]);
    var flyTo = function(location) {
        var zoom = getZoomForLocationType(location.zoneType);
        [
            smallMap,
            mediumMap,
            largeMap
        ].forEach(function(map) {
            var ref;
            (ref = map.current) === null || ref === void 0 ? void 0 : ref.flyTo({
                center: location.coordinates,
                zoom: zoom
            });
        });
    };
    var mapMarkers = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        setTopMarker(null);
        var selectedAddressToken = propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken;
        var ref3, ref4;
        var markers = (ref2 = (ref1 = propertySearchData === null || propertySearchData === void 0 ? void 0 : (ref = propertySearchData.results) === null || ref === void 0 ? void 0 : ref.slice().sort(function(a, b) {
            var ref, ref1;
            return ((ref3 = (ref = b.location) === null || ref === void 0 ? void 0 : ref.lat) !== null && ref3 !== void 0 ? ref3 : 0) - ((ref4 = (ref1 = a.location) === null || ref1 === void 0 ? void 0 : ref1.lat) !== null && ref4 !== void 0 ? ref4 : 0);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(p, idx) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMapMarker, {
                detailCache: markerDetailsCache,
                property: p,
                topMarker: topMarker,
                handleFetchPropertyDetails: handleFetchPropertyDetails,
                setTopMarker: setTopMarker,
                index: idx,
                isSelected: p.addressToken === selectedAddressToken,
                isLoading: p.addressToken === loadingAddressToken
            }, p.id);
        })) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean);
        return markers !== null && markers !== void 0 ? markers : [];
    }, [
        propertySearchData,
        propertyReactions,
        propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken,
        loadingAddressToken
    ]);
    var setPropertyResults = function(searchResult, listResult) {
        if (searchResult) {
            setPropertySearchData(searchResult);
        }
        setPropertyListData(listResult !== null && listResult !== void 0 ? listResult : null);
    };
    var handleError = function(key, val) {
        if (val === "") {
            return setErrors(function(prev) {
                if (prev && prev[key]) {
                    delete prev[key];
                    return (0,_object_spread/* default */.Z)({}, prev);
                }
                return;
            });
        }
        return setErrors(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, val));
        });
    };
    var getReactions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, reactions, reducedReactions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(isLoggedIn && (user === null || user === void 0 ? void 0 : user.customerUuid))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,api/* getAthenaClient */.k8)().GetBuyerPropertyReactions({
                                customerId: user.customerUuid
                            })
                        ];
                    case 1:
                        reactions = _state.sent();
                        reducedReactions = reactions === null || reactions === void 0 ? void 0 : (ref = reactions.buyerService) === null || ref === void 0 ? void 0 : (ref1 = ref.getBuyer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.buyer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reactions) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(reactions, reaction) {
                            reactions[reaction.addressId] = reaction.reaction;
                            return reactions;
                        }, {});
                        setPropertyReactions(reducedReactions);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function getReactions() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.identifier) {
            var urlParams = buildQueryParams(queryParams);
            window.history.pushState({}, "", "/homes/".concat(marketInfo.identifier, "?").concat(urlParams));
        }
    }, []);
    (0,react.useEffect)(function() {
        getReactions();
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("propertyReactionEvent", getReactions);
        return function() {
            return window.removeEventListener("propertyReactionEvent", getReactions);
        };
    }, []);
    // Track property view events
    (0,react.useEffect)(function() {
        if (showPdp && propertyDetails) {
            trackJourneyEvent("marketplaceProperty", "detailPageView", {
                addressUuid: propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken
            });
        }
    }, [
        showPdp,
        propertyDetails
    ]);
    // Close the PDP (if open) when a user taps on the browser's back button
    (0,react.useEffect)(function() {
        var handleBackButton = function() {
            hidePropertyDetails();
            var urlParams = removeAddressPreviewParams();
            window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        };
        window.addEventListener("popstate", handleBackButton);
        return function() {
            return window.removeEventListener("popstate", handleBackButton);
        };
    }, []);
    // Smaller filter menu on desktop that allows for immediate querying
    var handleQuickFilterChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(bedrooms, bathrooms) {
            var payload, ref, searchResult, listResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingFilter(true);
                        setIsLoadingResults(true);
                        handleSetBedrooms(bedrooms);
                        handleSetBathrooms(bathrooms);
                        updateQueryParams((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchState.getCanonical()), {
                            bedrooms: Number(bedrooms),
                            bathrooms: Number(bathrooms)
                        }));
                        payload = searchState.buildSearchPayload({
                            bathrooms: Number(bathrooms),
                            bedrooms: Number(bedrooms),
                            market: marketInfo.name,
                            vertices: vertices,
                            zoneIds: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value) ? [
                                selectedLocation.value
                            ] : null
                        });
                        return [
                            4,
                            getPropertyListAndSearch(payload)
                        ];
                    case 1:
                        ref = _state.sent(), searchResult = ref.searchResult, listResult = ref.listResult;
                        setPropertyResults(searchResult.marketplace.propertySearch, listResult.marketplace.propertyList);
                        searchState.resetPage();
                        setIsLoadingFilter(false);
                        setIsLoadingResults(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleQuickFilterChange(bedrooms, bathrooms) {
            return _ref.apply(this, arguments);
        };
    }();
    // Full filter menu that allows for more advanced filtering on desktop
    var handleOnFilterClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, payload, ref2, searchResult, listResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingFilter(true);
                        setIsLoadingResults(true);
                        updateQueryParams(searchState.getCanonical());
                        payload = searchState.buildSearchPayload({
                            market: marketInfo.name,
                            vertices: vertices,
                            zoneIds: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value) ? [
                                selectedLocation.value
                            ] : null
                        });
                        return [
                            4,
                            getPropertyListAndSearch(payload)
                        ];
                    case 1:
                        ref2 = _state.sent(), searchResult = ref2.searchResult, listResult = ref2.listResult;
                        setPropertyResults(searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.marketplace) === null || ref === void 0 ? void 0 : ref.propertySearch, (ref1 = listResult.marketplace) === null || ref1 === void 0 ? void 0 : ref1.propertyList);
                        searchState.resetPage();
                        setIsLoadingFilter(false);
                        setIsLoadingResults(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnFilterClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Mobile filter menu CTA click handler to trigger a search, close the filter menu, and fly to the selected location
    var handleMobileFilterClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selectedLocation) {
                            flyTo(selectedLocation);
                        }
                        return [
                            4,
                            handleOnFilterClick()
                        ];
                    case 1:
                        _state.sent();
                        setShowFilters(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMobileFilterClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Load more properties in the list view
    var handleOnSeeMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var payload, res, propertyList, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(propertyListData === null || propertyListData === void 0 ? void 0 : propertyListData.nextPage)) return [
                            3,
                            4
                        ];
                        payload = searchState.buildSearchPayload((0,_object_spread/* default */.Z)({
                            market: marketInfo.name
                        }, vertices && {
                            vertices: vertices
                        }, (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value) && {
                            zoneIds: [
                                selectedLocation.value
                            ]
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getPropertyList(payload, pageNumber + 1)
                        ];
                    case 2:
                        res = _state.sent();
                        propertyList = res.marketplace.propertyList;
                        if (!propertyList) {
                            return [
                                2
                            ];
                        }
                        setPropertyListData(function(prev) {
                            if (prev === null || prev === void 0 ? void 0 : prev.results) {
                                var ref, ref1;
                                return {
                                    results: (0,_to_consumable_array/* default */.Z)(prev.results).concat((0,_to_consumable_array/* default */.Z)((ref = propertyList === null || propertyList === void 0 ? void 0 : propertyList.results) !== null && ref !== void 0 ? ref : [])),
                                    count: (ref1 = propertyList === null || propertyList === void 0 ? void 0 : propertyList.count) !== null && ref1 !== void 0 ? ref1 : 0,
                                    nextPage: propertyList === null || propertyList === void 0 ? void 0 : propertyList.nextPage
                                };
                            }
                            return propertyList;
                        });
                        searchState.set.setPageNumber(pageNumber + 1);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        esm_exports/* captureException */.Tb(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSeeMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var setSearchAreaFromMapBounds = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(map) {
            var coordinates, queryParams, payload, ref, searchResult, listResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingResults(true);
                        coordinates = (0,utils/* getShapeFromMap */.a)(map);
                        queryParams = buildVerticesQueryParams(coordinates);
                        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(queryParams));
                        setPropertyListData(null);
                        updateQueryParams(searchState.getCanonical());
                        payload = searchState.buildSearchPayload({
                            vertices: coordinates
                        });
                        return [
                            4,
                            getPropertyListAndSearch(payload)
                        ];
                    case 1:
                        ref = _state.sent(), searchResult = ref.searchResult, listResult = ref.listResult;
                        setPropertyResults(searchResult.marketplace.propertySearch, listResult.marketplace.propertyList);
                        searchState.resetPage();
                        setVertices(coordinates);
                        setIsLoadingFilter(false);
                        setIsLoadingResults(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(map) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setVertices,
        setPropertySearchData,
        setPropertyListData,
        marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.name,
        minBeds,
        minBaths,
        canSelfTour,
        minPrice,
        maxPrice,
        minSquareFootage,
        maxSquareFootage,
        singleStory,
        mustHavePool,
        singleFamily,
        condo,
        townhome,
        minYearBuilt,
        maxYearBuilt, 
    ]);
    var hidePropertyDetails = (0,react.useCallback)(function() {
        setShowPdp(false);
    }, []);
    var closePropertyDetails = (0,react.useCallback)(function() {
        setShowPdp(false);
        setPropertyDetails(null);
        var urlParams = removeAddressPreviewParams();
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
    }, []);
    var debouncedSetSearchAreaFromViewport = (0,index_module/* useDebouncedCallback */.y1)(setSearchAreaFromMapBounds, 200);
    var handleOnMoveEnd = (0,react.useCallback)(function(e) {
        debouncedSetSearchAreaFromViewport(e.target);
    }, [
        debouncedSetSearchAreaFromViewport
    ]);
    var handleSetBedrooms = function(value) {
        return searchState.set.setBedrooms(Number(value));
    };
    var handleSetBathrooms = function(value) {
        return searchState.set.setBathrooms(Number(value));
    };
    var handleSetCanSelfTour = function(value) {
        return searchState.set.setCanSelfTour(value === "true");
    };
    var handleMinPriceChange = function(minPrice) {
        return searchState.set.setMinPrice(Number(minPrice) / 100);
    };
    var handleMaxPriceChange = function(maxPrice) {
        return searchState.set.setMaxPrice(Number(maxPrice) / 100);
    };
    var handleSingleFamilyChange = function(_, checked) {
        return searchState.set.setSingleFamily(!!checked);
    };
    var handleCondoChange = function(_, checked) {
        return searchState.set.setCondo(!!checked);
    };
    var handleTownhomeChange = function(_, checked) {
        return searchState.set.setTownhome(!!checked);
    };
    var handleNoHoasChange = function(_, checked) {
        return searchState.set.setNoHoas(!!checked);
    };
    var handleSingleStoryChange = function(_, checked) {
        return searchState.set.setSingleStory(!!checked);
    };
    var handlePoolChange = function(_, checked) {
        return searchState.set.setMustHavePool(!!checked);
    };
    var handleMinYearBuiltChange = function(minYearBuilt) {
        return searchState.set.setMinYearBuilt(Number(minYearBuilt));
    };
    var handleMaxYearBuiltChange = function(maxYearBuilt) {
        return searchState.set.setMaxYearBuilt(Number(maxYearBuilt));
    };
    var handleMinLotSizeChange = function(minLotSize) {
        return searchState.set.setMinLotSize(Number(minLotSize));
    };
    var handleMaxLotSizeChange = function(maxLotSize) {
        return searchState.set.setMaxLotSize(Number(maxLotSize));
    };
    var handleMinSquareFootageChange = function(min) {
        return searchState.set.setMinSquareFootage(Number(min));
    };
    var handleMaxSquareFootageChange = function(max) {
        return searchState.set.setMaxSquareFootage(Number(max));
    };
    var handleShowList = function() {
        setShowList(true);
    };
    var handleShowMap = function() {
        return setShowList(false);
    };
    var onFiltersButtonClick = function() {
        setPropertyDetails(null);
        closePropertyDetails();
        setShowList(false);
        setShowPdp(false);
        setShowFilters(true);
    };
    var handleSetSelectedLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(location) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!location) {
                    setSelectedLocation(undefined);
                    return [
                        2
                    ];
                }
                setIsLoadingResults(true);
                setIsLoadingFilter(true);
                setSelectedLocation(location);
                setVertices([]);
                setIsMobileHeaderFocused(false);
                flyTo(location);
                window.history.pushState({}, "", "/homes/zid_".concat(location.value));
                return [
                    2
                ];
            });
        });
        return function handleSetSelectedLocation(location) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetSelectedAddress = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
            var urlParams;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!address) {
                    setSelectedAddress(undefined);
                    return [
                        2
                    ];
                }
                setSelectedAddress(address);
                handleFetchPropertyDetails(address.addressToken);
                setIsMobileHeaderFocused(false);
                urlParams = buildAddressPreviewParams(address.addressToken);
                window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
                return [
                    2
                ];
            });
        });
        return function handleSetSelectedAddress(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnMobileFilterClick = function() {
        setShowList(false);
        setShowPdp(false);
        setShowFilters(true);
    };
    var ref19 = (0,react.useState)(false), isMobileHeaderFocused = ref19[0], setIsMobileHeaderFocused = ref19[1];
    var handleOnMobileHeaderFocus = function() {
        setIsMobileHeaderFocused(true);
    };
    var handleOnMobileHeaderBlur = function() {
        setIsMobileHeaderFocused(false);
    };
    var handleOnViewFavorites = function() {
        setActiveTab(FloatingNavigationBar/* ActiveTab.Favorites */.w.Favorites);
        window.location.assign("/favorites");
    };
    var RenderBody = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketplaceMapLayout/* default */.Z, {
        header: header,
        footer: footer,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $smallerThanMD: {
                    flexDirection: "column"
                },
                $largerThanSM: {
                    flexDirection: "row"
                },
                overflow: "hidden",
                height: "100%",
                width: "100%",
                backgroundColor: "$backgroundPrimary",
                position: "relative",
                borderTopWidth: "$1x",
                borderTopColor: "$borderPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: isMobileHeaderFocused ? "95%" : "calc(100% - 200px)",
                        height: 60,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        top: 5,
                        zIndex: 8000,
                        left: isMobileHeaderFocused ? 10 : 55,
                        onBlur: handleOnMobileHeaderBlur,
                        onFocus: handleOnMobileHeaderFocus,
                        style: {
                            position: "fixed",
                            transition: "width 0.25s, left 0.25s"
                        },
                        $largerThanSM: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "100%",
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileHeaderFilters, {
                                isFocused: isMobileHeaderFocused,
                                setSelectedAddress: handleSetSelectedAddress,
                                selectedAddress: selectedAddress,
                                setSelectedLocation: handleSetSelectedLocation,
                                selectedLocation: selectedLocation,
                                onBack: handleOnMobileHeaderBlur,
                                onOpenFilters: handleOnMobileFilterClick
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        "aria-hidden": showList || showFilters,
                        opacity: showList || showFilters ? 0 : 1,
                        style: {
                            transition: showList || showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showList || showFilters ? "hidden" : "visible"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                                mapRef: smallMap,
                                handleOnClick: closePropertyDetails,
                                handleOnMoveEnd: handleOnMoveEnd,
                                marketShape: marketInfo.shape,
                                mapMarkers: mapMarkers
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                bottom: 80,
                                width: 80,
                                marginHorizontal: "auto",
                                padding: 6,
                                analyticsName: "list-view",
                                label: "List",
                                "data-testid": "mobile-list-view",
                                onPress: handleShowList,
                                size: "small",
                                variant: "secondaryInverse",
                                mb: 30,
                                display: showList ? "none" : "flex",
                                style: {
                                    position: "fixed"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $largerThanMD: {
                            display: "none"
                        },
                        flexBasis: "50%",
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        "aria-hidden": showFilters,
                        opacity: showFilters ? 0 : 1,
                        style: {
                            transition: showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showFilters ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                            mapRef: mediumMap,
                            handleOnClick: closePropertyDetails,
                            handleOnMoveEnd: handleOnMoveEnd,
                            marketShape: marketInfo.shape,
                            mapMarkers: mapMarkers
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanLG: {
                            display: "none"
                        },
                        flexBasis: "50%",
                        flex: 1,
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                            mapRef: largeMap,
                            handleOnClick: closePropertyDetails,
                            handleOnMoveEnd: handleOnMoveEnd,
                            marketShape: marketInfo.shape,
                            mapMarkers: mapMarkers
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        id: "small-property-list",
                        $largerThanSM: {
                            display: "none"
                        },
                        alignItems: "center",
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        zIndex: 3,
                        px: 20,
                        backgroundColor: "$backgroundPrimary",
                        "aria-hidden": !showList,
                        opacity: showList ? 1 : 0,
                        style: {
                            overflowY: "scroll",
                            transition: showList ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showList ? "visible" : "hidden",
                            transform: showList ? "" : "translateY(100vh)"
                        },
                        marginHorizontal: "auto",
                        pb: 130,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                width: "100%",
                                px: 24,
                                height: "100%",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                    pb: 52,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$bodySmall",
                                            my: 24,
                                            children: [
                                                propertySearchData === null || propertySearchData === void 0 ? void 0 : propertySearchData.count,
                                                " homes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyList, {
                                            isLoading: isLoadingResults,
                                            handleOnSeeMore: handleOnSeeMore,
                                            propertyListData: propertyListData
                                        }),
                                        activeMarkets && activeMarkets.length > 0 && !isLoadingResults && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            mt: 48,
                                            mb: 110,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "p",
                                                    typography: "$bodyMedium",
                                                    mb: 24,
                                                    fontWeight: "$medium",
                                                    children: "Popular Markets"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                                    style: {
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                                                        gap: "16px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                            href: "/homes-for-sale-near-me",
                                                            display: "block",
                                                            analyticsName: "market-link-near-me",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                tag: "p",
                                                                typography: "$bodyMedium",
                                                                color: "$contentSecondary",
                                                                children: "Homes for sale near me"
                                                            })
                                                        }),
                                                        activeMarkets.map(function(market) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                                href: "/homes/".concat(market.identifier),
                                                                display: "block",
                                                                analyticsName: "market-link-".concat(market.identifier),
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                                    tag: "p",
                                                                    typography: "$bodyMedium",
                                                                    color: "$contentSecondary",
                                                                    children: [
                                                                        "Houses for sale in ",
                                                                        market.displayName
                                                                    ]
                                                                })
                                                            }, market.identifier);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                bottom: 80,
                                width: 80,
                                marginHorizontal: "auto",
                                padding: 6,
                                display: showList ? "flex" : "none",
                                analyticsName: "list-view",
                                "data-testid": "mobile-map-view",
                                alignSelf: "center",
                                label: "Map",
                                onPress: handleShowMap,
                                size: "small",
                                variant: "secondaryInverse",
                                mb: 30,
                                style: {
                                    position: "fixed"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "property-list-container",
                        flexDirection: "column",
                        $smallerThanMD: {
                            display: "none"
                        },
                        backgroundColor: "$backgroundPrimary",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        flexBasis: "50%",
                        position: "relative",
                        "aria-hidden": showPdp || showFilters,
                        opacity: showPdp || showFilters ? 0 : 1,
                        style: {
                            transition: showPdp || showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showPdp || showFilters ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            height: "100%",
                            px: 48,
                            pt: 12,
                            display: "flex",
                            width: "100%",
                            zIndex: 1,
                            "data-testid": "desktop-property-list",
                            style: {
                                overflowY: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuickFilters, {
                                    bedrooms: String(minBeds),
                                    bathrooms: String(minBaths),
                                    selectedAddress: selectedAddress,
                                    setSelectedAddress: handleSetSelectedAddress,
                                    setSelectedLocation: handleSetSelectedLocation,
                                    selectedLocation: selectedLocation,
                                    onFilterChange: handleQuickFilterChange,
                                    isLoadingFilter: isLoadingFilter,
                                    onFiltersButtonClick: onFiltersButtonClick,
                                    isFocused: isMobileHeaderFocused
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    mb: 24,
                                    children: [
                                        propertySearchData === null || propertySearchData === void 0 ? void 0 : propertySearchData.count,
                                        " homes for sale near",
                                        " ",
                                        (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label) || (marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.displayName) || "you"
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyList, {
                                    isLoading: isLoadingResults,
                                    handleOnSeeMore: handleOnSeeMore,
                                    propertyListData: propertyListData
                                }),
                                activeMarkets && activeMarkets.length > 0 && !isLoadingResults && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    mt: 48,
                                    mb: 100,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$bodyMedium",
                                            mb: 24,
                                            fontWeight: "$medium",
                                            children: "Popular Markets"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            style: {
                                                display: "grid",
                                                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                                                gap: "16px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                    href: "/homes-for-sale-near-me",
                                                    display: "block",
                                                    analyticsName: "market-link-near-me",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "p",
                                                        typography: "$bodyMedium",
                                                        color: "$contentSecondary",
                                                        children: "Homes for sale near me"
                                                    })
                                                }),
                                                activeMarkets.map(function(market) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                        href: "/homes/".concat(market.identifier),
                                                        display: "block",
                                                        analyticsName: "market-link-".concat(market.identifier),
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$bodyMedium",
                                                            color: "$contentSecondary",
                                                            children: [
                                                                "Houses for sale in ",
                                                                market.displayName
                                                            ]
                                                        })
                                                    }, market.identifier);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "small-medium-filters",
                        $largerThanMD: {
                            display: "none"
                        },
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        zIndex: 15000,
                        top: -5,
                        backgroundColor: "$backgroundPrimary",
                        "aria-hidden": !showFilters,
                        opacity: showFilters ? 1 : 0,
                        style: {
                            position: "fixed",
                            transition: showFilters ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showFilters ? "visible" : "hidden",
                            transform: showFilters ? "" : "translateY(-100vh)"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapSearchFilters, {
                            minBeds: toFilterString(minBeds),
                            minBaths: toFilterString(minBaths),
                            canSelfTour: canSelfTour,
                            minPrice: dollarToCentsString(minPrice),
                            maxPrice: dollarToCentsString(maxPrice),
                            singleFamily: singleFamily,
                            condo: condo,
                            townhome: townhome,
                            noHoas: noHoas,
                            singleStory: singleStory,
                            mustHavePool: mustHavePool,
                            minYearBuilt: toFilterString(minYearBuilt),
                            maxYearBuilt: toFilterString(maxYearBuilt),
                            minLotSize: toFilterString(minLotSize),
                            maxLotSize: toFilterString(maxLotSize),
                            minSquareFootage: toFilterString(minSquareFootage),
                            maxSquareFootage: toFilterString(maxSquareFootage),
                            handleError: handleError,
                            handleMinBedsChange: handleSetBedrooms,
                            handleMinBathsChange: handleSetBathrooms,
                            onCanSelfTourChange: handleSetCanSelfTour,
                            handleMinSquareFootageChange: handleMinSquareFootageChange,
                            handleMaxSquareFootageChange: handleMaxSquareFootageChange,
                            handleMinPriceChange: handleMinPriceChange,
                            handleMaxPriceChange: handleMaxPriceChange,
                            handleSingleFamilyChange: handleSingleFamilyChange,
                            handleCondoChange: handleCondoChange,
                            handleTownhomeChange: handleTownhomeChange,
                            handleNoHoasChange: handleNoHoasChange,
                            handleSingleStoryChange: handleSingleStoryChange,
                            handlePoolChange: handlePoolChange,
                            handleMinYearBuiltChange: handleMinYearBuiltChange,
                            handleMaxYearBuiltChange: handleMaxYearBuiltChange,
                            handleMinLotSizeChange: handleMinLotSizeChange,
                            handleMaxLotSizeChange: handleMaxLotSizeChange,
                            onApplyFilters: handleMobileFilterClick,
                            onResetFilters: searchState.resetFilters,
                            onClose: function() {
                                return setShowFilters(false);
                            },
                            isLoading: isLoadingResults,
                            errors: errors
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "pdp-filters-container",
                        flexDirection: "column",
                        $smallerThanLG: {
                            display: "none"
                        },
                        width: "50%",
                        height: "100%",
                        backgroundColor: "$backgroundPrimary",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        right: 0,
                        position: "absolute",
                        zIndex: 2,
                        "aria-hidden": !showFilters,
                        opacity: showFilters ? 1 : 0,
                        style: {
                            transition: showFilters ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showFilters ? "visible" : "hidden",
                            transform: showFilters ? "" : "translateX(50vh)"
                        },
                        "data-testid": "desktop-filters",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapSearchFilters, {
                            minBeds: toFilterString(minBeds),
                            minBaths: toFilterString(minBaths),
                            canSelfTour: canSelfTour,
                            minPrice: dollarToCentsString(minPrice),
                            maxPrice: dollarToCentsString(maxPrice),
                            singleFamily: singleFamily,
                            condo: condo,
                            townhome: townhome,
                            noHoas: noHoas,
                            singleStory: singleStory,
                            mustHavePool: mustHavePool,
                            minYearBuilt: toFilterString(minYearBuilt),
                            maxYearBuilt: toFilterString(maxYearBuilt),
                            minLotSize: toFilterString(minLotSize),
                            maxLotSize: toFilterString(maxLotSize),
                            minSquareFootage: toFilterString(minSquareFootage),
                            maxSquareFootage: toFilterString(maxSquareFootage),
                            handleError: handleError,
                            handleMinBedsChange: handleSetBedrooms,
                            handleMinBathsChange: handleSetBathrooms,
                            onCanSelfTourChange: handleSetCanSelfTour,
                            handleMinSquareFootageChange: handleMinSquareFootageChange,
                            handleMaxSquareFootageChange: handleMaxSquareFootageChange,
                            handleMinPriceChange: handleMinPriceChange,
                            handleMaxPriceChange: handleMaxPriceChange,
                            handleSingleFamilyChange: handleSingleFamilyChange,
                            handleCondoChange: handleCondoChange,
                            handleTownhomeChange: handleTownhomeChange,
                            handleNoHoasChange: handleNoHoasChange,
                            handleSingleStoryChange: handleSingleStoryChange,
                            handlePoolChange: handlePoolChange,
                            handleMinYearBuiltChange: handleMinYearBuiltChange,
                            handleMaxYearBuiltChange: handleMaxYearBuiltChange,
                            handleMinLotSizeChange: handleMinLotSizeChange,
                            handleMaxLotSizeChange: handleMaxLotSizeChange,
                            onApplyFilters: handleOnFilterClick,
                            onResetFilters: searchState.resetFilters,
                            onClose: function() {
                                return setShowFilters(false);
                            },
                            isLoading: isLoadingResults,
                            errors: errors
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "column",
                        $smallerThanMD: {
                            display: "none"
                        },
                        height: "100%",
                        width: "50%",
                        backgroundColor: "$backgroundPrimary",
                        borderTopColor: "$borderPrimary",
                        position: "absolute",
                        right: 0,
                        zIndex: 2,
                        "aria-hidden": !showFilters,
                        opacity: showPdp ? 1 : 0,
                        style: {
                            overflowY: "scroll",
                            transition: showPdp ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showPdp ? "visible" : "hidden",
                            transform: showPdp ? "" : "translateX(50vh)"
                        },
                        children: propertyDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiniPropertyDetailPage, {
                            property: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyDetails), {
                                isLiked: isLiked,
                                onClickReaction: onClickReaction
                            }),
                            onClose: closePropertyDetails
                        }, propertyDetails.addressToken)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        position: "absolute",
                        width: "calc(100% - 20px)",
                        marginHorizontal: "$5x",
                        height: "75vh",
                        backgroundColor: "$backgroundPrimary",
                        borderTopLeftRadius: "$16x",
                        borderTopRightRadius: "$16x",
                        overflow: "hidden",
                        zIndex: 3000,
                        "aria-hidden": !showPdp,
                        opacity: showPdp ? 1 : 0,
                        bottom: 0,
                        style: {
                            transition: showPdp ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showPdp ? "visible" : "hidden",
                            transform: showPdp ? "" : "translateY(75vh)"
                        },
                        children: propertyDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMiniPropertyDetailPage, {
                            property: propertyDetails,
                            onClose: closePropertyDetails
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingNavigationBar/* FloatingNavigationBar */.u, {
                handleOnViewFavorites: handleOnViewFavorites,
                activeTab: activeTab,
                shouldHide: showPdp
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceSeoHead, {
                marketInfo: marketInfo,
                activeMarkets: activeMarkets,
                canonicalOverride: canonicalOverride !== null && canonicalOverride !== void 0 ? canonicalOverride : undefined
            }),
            RenderBody
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _market_ = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6523,5527,6180,6500,5569,5662,7982,3089,7166,9167,523,7203,9007,9652,6398,5675,2864,6461,4746,6236,347,9650,1769,2484,9722,9879,7939,1462,940,6104,8834,3834,9585,2393,9774,2888,179], function() { return __webpack_exec__(27805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);